<template>
  <el-menu
    :class="menuAsideClass"
    background-color="transparent"
    :default-active="activePath"
    :collapse="isCollapse"
    :unique-opened="themeConfig.isUniqueOpened"
    :collapse-transition="true"
    @select="handleMenuSelect"
 >
    <template v-for="val in menuList" :key="val.path">
      <el-sub-menu v-if="val.children?.length" :index="val.path">
        <template #title>
          <menu-icon :icon="val.icon" /><span>{{ val.title }}</span>
        </template>
        <sub-item :chil="val.children" />
      </el-sub-menu>
      <el-menu-item v-else :index="val.path">
        <menu-icon :icon="val.icon" /><template #title>
          <span>{{ val.title }}</span>
        </template>
      </el-menu-item>
    </template>
  </el-menu>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import useCrmebThemeConfigStore from '@/store/modules/themeConfig';
import type { CrmebNavMenuItem } from '@/utils/crmebMenu';
import { ensureCrmebPrefix } from '@/utils/crmebMenu';
import SubItem from './SubItem.vue';
import MenuIcon from '../components/MenuIcon.vue';

defineProps<{
  menuList: CrmebNavMenuItem[];
}>();

const route = useRoute();
const router = useRouter();
const themeStore = useCrmebThemeConfigStore();
const themeConfig = computed(() => themeStore.themeConfig);

/** 分栏/经典子菜单用 columns-round|card（对齐 EB vertical.vue） */
const menuAsideClass = computed(() => {
  const layout = themeConfig.value.layout;
  if (layout === 'columns' || layout === 'classic') {
    return themeConfig.value.columnsAsideStyle;
  }
  return '';
});

const activePath = computed(() =>
  ensureCrmebPrefix(String((route.meta?.activeMenu as string) || route.path)),
);

const isCollapse = computed(() => {
  if (typeof document !== 'undefined' && document.body.clientWidth < 1000) {
    return false;
  }
  const layout = themeConfig.value.layout;
  // 分栏/经典：isCollapse 只控制侧栏宽度，子菜单树不使用 ep collapse（否则会隐藏展开箭头）
  if (layout === 'columns' || layout === 'classic') {
    return false;
  }
  return themeConfig.value.isCollapse;
});

function closeMobileDrawerIfNeeded() {
  // 对齐 EB vertical.vue：$route 变化时移动端关闭抽屉（isCollapse=false）
  if (typeof document !== 'undefined' && document.body.clientWidth < 1000) {
    themeStore.setCollapse(false);
  }
}

function handleMenuSelect(index: string) {
  if (index.startsWith('http://') || index.startsWith('https://')) {
    window.open(index, '_blank');
    closeMobileDrawerIfNeeded();
    return;
  }
  router.push(index);
  closeMobileDrawerIfNeeded();
}

watch(
  () => route.path,
  () => {
    closeMobileDrawerIfNeeded();
  },
);
</script>
